import api from "lib/api";

export const getPayrollPeriodList = async (params = {}) => {
    return await api.post(
        "/v1/payrollPeriod/getPayrollPeriodYear",
        params
    );
};
export const getPayrollPeriodListPage = async (params = {}) => {
    return await api.post(
        "/v1/payrollPeriod/getPayrollPeriodYearPage",
        params
    );
};

export const createPayrollPeriod = async (params = {}) => {
    return await api.post(
        "/v1/payrollPeriod/createPayrollPeriod",
        params
    );
};

export const employmentTypeOption = async (params = {}) => {
    return await api.post(
        "/v1/employmentTypeSetup/getEmploymentTypeSetup",
        params
    );
};

export const startPeriodOnFlowHr = async (params = {}) => {
    return await api.post(
        "/v1/payrollPeriod/getGeneratePeriodInYear",
        params
    );
};

export const updatePayrollPeriod = async (params = {}) => {
    return await api.post(
        "/v1/payrollPeriod/updatePayrollPeriod",
        params
    );
};

export const createPayrollSpecialPeriod = async (params = {}) => {
    return await api.post(
        "/v1/payrollPeriod/createPayrollSpecialPeriod",
        params
    )
}

export const specialPeriodOption = async (params = {}) => {
    return await api.post(
        "/v1/payrollPeriod/getGeneratePeriodSpecialInYear",
        params
    )
}

export const getIncomeForSpecialPeriod = async (params = {}) => {
    return await api.post(
        "/v1/dropdown/getIncomeForSpecialPeriod",
        params
    )
}

export const getDeductionForSpecialPeriod = async (params = {}) => {
    return await api.post(
        "/v1/dropdown/getDeductionForSpecialPeriod",
        params
    )
}

export const getPayrollPeriod = async (params) => {
    return await api.post("/v1/payment/getPayrollPeriod", params);
}


export const editPayment = async (params) => {
    return await api.post("/v1/payment/createPayment", { ...params, timeout: 999999999 });
}

export const createPaymentByEmployeeIds = async (params) => {
    return await api.post("/v1/payment/createPaymentByEmployeeIds", params);
}
export const getPayrollPeriodDetails = async (params) => {
    return await api.post("/v1/payrollPeriod/getPayrollPeriodDetails", params);
}

export const exportTxnPaymentByTxnPayrollPeriodId = async (params) => {
    return await api.post("/v1/payment/exportTxnPaymentByTxnPayrollPeriodId", { ...params, timeout: 999999999 }, { responseType: 'blob' });
}